import React, { Component } from 'react'
import {
	withStyles,
	Grid,
	ExpansionPanel,
	ExpansionPanelSummary,
	ExpansionPanelDetails,
	Typography,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Button from 'components/theme/Button'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import 'hammerjs'
import {
	Chart,
	ChartSeries,
	ChartSeriesItem,
	// ChartTitle,
	ChartCategoryAxis,
	ChartCategoryAxisTitle,
	ChartCategoryAxisItem,
} from '@progress/kendo-react-charts'
import {
	readNextAnalyticsPage,
	prevAnalyticsPage,
	nextAnalyticsPage,
} from '../../../../../../actions/customForm/addOrEdit'
import classNames from 'classnames'
import { words } from 'lodash'
import afinn from 'afinn-165'

const commonStyles = (theme) => ({
	tableCellContent: {
		whiteSpace: 'nowrap',
		display: 'table',
		tableLayout: 'fixed',
		width: '100%',
	},
	tableCellText: {
		display: 'table-cell',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
})

const styles = (theme) => ({
	...commonStyles(theme),
	listItem: {
		// '&:hover': {
		// 	backgroundColor: '#b2b2b2',
		// 	cursor: 'pointer',
		// },
		padding: 15,
	},
	listItemText: {
		fontSize: 18,
	},
})

const TextFieldChart = connect(
	(state, { statsId }) => {
		const analytics = state.customForm.addOrEdit.analyticsAnswerPages[statsId]
		const { page, pages, cursor } = analytics
		return { page, pages, cursor }
	},
	(dispatch) =>
		bindActionCreators(
			{ readNextAnalyticsPage, prevAnalyticsPage, nextAnalyticsPage },
			dispatch,
		),
)(
	withStyles(styles)(
		({
			section,
			stats,
			classes,
			page,
			pages,
			cursor,
			statsId,
			readNextAnalyticsPage,
			prevAnalyticsPage,
			nextAnalyticsPage,
		}) => (
			<div>
				<div
					style={{
						marginTop: 10,
						backgroundColor: '#014c94',
						color: '#fff',
						fontSize: 20,
						padding: 10,
						borderRadius: 35,
						marginBottom: 10,
					}}
				>
					{stats?.field_submits} total response
					{stats?.field_submits === 1 ? '' : 's'}
				</div>
				<div
					style={{
						border: '1px solid gray',
						borderRadius: 20,
						overflow: 'hidden',
					}}
				>
					{pages?.[page]?.map((response, idx) => {
						const score = words(response?.text)?.reduce((sum, word) => {
							sum += afinn[word] || 0
							return sum
						}, 0)

						return (
							<div
								style={idx === 0 ? {} : { borderTop: '1px solid gray' }}
								className={classes.listItem}
								key={`${stats?.field_name}${response?.timestamp}`}
							>
								<div
									className={classNames(
										classes.listItemText,
										classes.tableCellContent,
									)}
								>
									<span className={classes.tableCellText}>
										{response?.text}
									</span>
								</div>
								<div
									style={{ marginTop: 7 }}
									className={classNames(classes.tableCellContent)}
								>
									<span
										style={{ fontWeight: '500', fontSize: 14 }}
										className={classes.tableCellText}
									>
										Answered:{' '}
										<span style={{ color: '#0d5499' }}>
											{new Date(
												response?.timestamp / 1000000,
											).toLocaleDateString()}
										</span>{' '}
										{score > 0 ? (
											<span
												style={{
													color: 'green',
												}}
											>
												☺
											</span>
										) : score < 0 ? (
											<span style={{ color: 'red' }}>☹</span>
										) : null}
									</span>
								</div>
							</div>
						)
					})}
				</div>
				{stats?.responses?.length < stats?.field_submits && (
					<div style={{ marginTop: 10 }}>
						<Grid container justify="space-between">
							<Grid item>
								<Button
									onClick={() => prevAnalyticsPage(statsId)}
									disabled={!page}
									variant="contained"
									color="primary"
								>
									Previous page
								</Button>
							</Grid>
							<Grid item>
								<Button
									disabled={!cursor && page === pages.length - 1}
									onClick={() => {
										if (page === pages.length - 1) {
											readNextAnalyticsPage({
												statsId,
												params: `?cur=${cursor}`,
											})
										} else {
											nextAnalyticsPage(statsId)
										}
									}}
									variant="contained"
									color="primary"
								>
									Next page
								</Button>
							</Grid>
						</Grid>
					</div>
				)}
			</div>
		),
	),
)

const NumFieldChart = connect(
	(state, { statsId }) => {
		const analytics = state.customForm.addOrEdit.analyticsAnswerPages[statsId]
		const { page, pages, cursor } = analytics
		return { page, pages, cursor }
	},
	(dispatch) =>
		bindActionCreators(
			{ readNextAnalyticsPage, prevAnalyticsPage, nextAnalyticsPage },
			dispatch,
		),
)(
	withStyles(styles)(
		({
			section,
			stats,
			classes,
			page,
			pages,
			cursor,
			statsId,
			readNextAnalyticsPage,
			prevAnalyticsPage,
			nextAnalyticsPage,
		}) => (
			<div>
				<div
					style={{
						marginTop: 10,
						backgroundColor: '#014c94',
						color: '#fff',
						fontSize: 20,
						padding: 10,
						borderRadius: 35,
						marginBottom: 10,
					}}
				>
					{stats?.field_submits} total response
					{stats?.field_submits === 1 ? '' : 's'}
				</div>
				<div
					style={{
						border: '1px solid gray',
						borderRadius: 20,
						overflow: 'hidden',
					}}
				>
					{pages?.[page]?.map((response, idx) => (
						<div
							style={idx === 0 ? {} : { borderTop: '1px solid gray' }}
							className={classes.listItem}
							key={`${stats?.field_name}${response?.timestamp}`}
						>
							<div
								className={classNames(
									classes.listItemText,
									classes.tableCellContent,
								)}
							>
								<span className={classes.tableCellText}>
									{response?.number}
								</span>
							</div>
							<div
								style={{ marginTop: 7 }}
								className={classNames(classes.tableCellContent)}
							>
								<span
									style={{ fontWeight: '500', fontSize: 14 }}
									className={classes.tableCellText}
								>
									Answered:{' '}
									<span style={{ color: '#0d5499' }}>
										{new Date(
											response?.timestamp / 1000000,
										).toLocaleDateString()}
									</span>
								</span>
							</div>
						</div>
					))}
				</div>
				{stats?.responses?.length < stats?.field_submits && (
					<div style={{ marginTop: 10 }}>
						<Grid container justify="space-between">
							<Grid item>
								<Button
									onClick={() => prevAnalyticsPage(statsId)}
									disabled={!page}
									variant="contained"
									color="primary"
								>
									Previous page
								</Button>
							</Grid>
							<Grid item>
								<Button
									disabled={!cursor && page === pages.length - 1}
									onClick={() => {
										if (page === pages.length - 1) {
											readNextAnalyticsPage({
												statsId,
												params: `?cur=${cursor}`,
											})
										} else {
											nextAnalyticsPage(statsId)
										}
									}}
									variant="contained"
									color="primary"
								>
									Next page
								</Button>
							</Grid>
						</Grid>
					</div>
				)}
			</div>
		),
	),
)

const barChartColors = ['#014c94', '#006fd9', '#d5e6f8']

const fieldValueStyles = (theme) => ({
	...commonStyles(theme),
	heading: {
		fontSize: theme.typography.pxToRem(17),
		fontWeight: 'bold',
		color: '#fff',
	},
	expansionPanelSummaryRoot: {
		backgroundColor: '#014c94',
	},
	expansionPanelRoot: {
		borderRadius: '24px !important',
		overflow: 'hidden',
	},
	expansionPanelDetailsRoot: {
		padding: 0,
		display: 'block',
	},
	response: {
		padding: 20,
		fontSize: 15,
		fontWeight: 'bold',
		position: 'relative',
	},
	tableCell: {
		display: 'inline-block',
		width: '50%',
		[theme.breakpoints.down('sm')]: {
			width: '100%',
		},
	},
})

const FieldValueChart = withStyles(fieldValueStyles)(
	({ section, stats, classes }) => {
		return (
			<div>
				<Chart>
					{/* <ChartTitle text="Units sold" /> */}
					<ChartCategoryAxis>
						<ChartCategoryAxisItem
							categories={stats?.response_summary.map(
								(response) => response.option,
							)}
						>
							<ChartCategoryAxisTitle text="Possible answers" />
						</ChartCategoryAxisItem>
					</ChartCategoryAxis>
					<ChartSeries>
						<ChartSeriesItem
							type="bar"
							// gap={2}
							color={(point) => {
								// console.log(point)
								return barChartColors?.[point?.index % 3] || undefined
							}}
							stack={{
								type: '100%',
							}}
							spacing={0.25}
							data={stats?.response_summary?.map((response) => response.count)}
						/>
						<ChartSeriesItem
							type="bar"
							data={stats?.response_summary.map(
								(response) => stats.field_submits - response.count,
							)}
							color="#fff"
						/>
					</ChartSeries>
				</Chart>
				<div style={{ marginTop: 15 }}>
					<ExpansionPanel classes={{ root: classes.expansionPanelRoot }}>
						<ExpansionPanelSummary
							classes={{ root: classes.expansionPanelSummaryRoot }}
							expandIcon={<ExpandMoreIcon style={{ color: '#fff' }} />}
						>
							<Typography className={classes.heading}>
								Answer Analytics
							</Typography>
						</ExpansionPanelSummary>
						<ExpansionPanelDetails
							classes={{ root: classes.expansionPanelDetailsRoot }}
						>
							<div>
								{stats?.response_summary.map((response, idx) => (
									<div
										className={classes.response}
										style={
											idx === stats.response_summary.length - 1
												? {}
												: { borderBottom: '1px solid gray' }
										}
									>
										<div
											className={classes.tableCell}
											style={{ paddingRight: 10 }}
										>
											<div className={classes.tableCellContent}>
												<span className={classes.tableCellText}>
													{response.option}
												</span>
											</div>
										</div>
										<div className={classes.tableCell}>
											<div className={classes.tableCellContent}>
												<span className={classes.tableCellText}>
													Responses: {response.count} (
													{Math.round(
														(response.count / stats?.field_submits) * 100,
													)}
													%)
												</span>
											</div>
										</div>
									</div>
								))}
							</div>
						</ExpansionPanelDetails>
					</ExpansionPanel>
				</div>
			</div>
		)
	},
)

const fieldTypeComponentMap = {
	fieldvalue: FieldValueChart,
	textfield: TextFieldChart,
	numfield: NumFieldChart,
}

class ChartContainer extends Component {
	render() {
		const { section, stats, fieldType, statsId, last } = this.props
		const Component = fieldTypeComponentMap[fieldType]

		return (
			<div
				style={{
					margin: last ? '0 20px' : '0 20px 80px',
					position: 'relative',
				}}
			>
				<div
					style={{
						marginTop: 18.72,
						fontSize: 18.72,
						padding: 2,
						fontWeight: 'bold',
						marginBottom: -4,
					}}
				>
					{section.label}
					{section.field.required && <span style={{ color: 'red' }}>*</span>}
				</div>
				{section.description && (
					<div
						style={{
							marginBottom: '0px',
							marginTop: '1.72px',
							fontSize: '12.72px',
							padding: '2px',
						}}
					>
						{section.description}
					</div>
				)}
				<Component section={section} stats={stats} statsId={statsId} />
				{!last && (
					<div
						style={{
							backgroundColor: 'gray',
							height: 1,
							position: 'absolute',
							width: '100%',
							bottom: -47,
						}}
					/>
				)}
			</div>
		)
	}
}

export default connect(
	(state, { statsId }) => ({
		stats: state.data?.customFormStat?.[statsId],
	}),
	(dispatch) => bindActionCreators({}, dispatch),
)(withStyles(styles)(ChartContainer))
